export const styles = (theme) => {
  return {
    mainContainer: {
      display: 'flex',
      flexDirection: 'column',
      border: `1px solid ${theme.palette.custom.gray1}`,
      padding: '20px !important',
      borderRadius: '4px',
      backgroundColor: theme.palette.custom.white,
      width: '70%',
      marginRight: '20px'
    },
    heading: {
      display: 'flex',
      flexDirection: 'column'
    },
    link: {
      color: theme.palette.primary.main,
      fontSize: '12px',
      lineHeight: '12px'
    },
    margin: function(position, value) {
      switch (position.toLowerCase()) {
        case 'top':
          return { marginTop: value };
        case 'bottom':
          return { marginBottom: value };
        case 'left':
          return { marginLeft: value };
        case 'right':
          return { marginRight: value };
        default:
          return { margin: value };
      }
    }
  };
};
